import _objectSpread from "/home/gitlab-runner/builds/9dQn4WFF/0/digitraffic-sas/construcaribe-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import * as React from 'react';
import { useContext } from 'react';
import Offcanvas from './Offcanvas';
import NavbarContext from './NavbarContext';
import { jsx as _jsx } from "react/jsx-runtime";
var NavbarOffcanvas = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var context = useContext(NavbarContext);
  return /*#__PURE__*/_jsx(Offcanvas, _objectSpread(_objectSpread({
    ref: ref,
    show: !!(context != null && context.expanded)
  }, props), {}, {
    renderStaticNode: true
  }));
});
NavbarOffcanvas.displayName = 'NavbarOffcanvas';
export default NavbarOffcanvas;